module.exports = __webpack_public_path__ + "static/media/balkan.51aa6c7f.jpg";